export const HintReportsRoute = {
  HINT_REPORTS: 'smartslides',
  HINT_REPORTS_SLIDE: 'smartslides/slide',
  HINT_REPORTS_SLIDE_NEW: 'smartslides/slide/new',
  HINT_REPORTS_SLIDES: 'smartslides/slides',
  HINT_REPORTS_TEMPLATE: 'smartslides/template',
  HINT_REPORTS_TEMPLATES: 'smartslides/templates',
};

export const HintReportsPathName = {
  HINT_REPORTS: 'smartslides',
  HINT_REPORTS_FORM_NEW: 'hintreportsform:new',
  HINT_REPORTS_FORM: 'hintreportsform',
  HINT_REPORTS_GENERATE: 'hintreportsgenerate',
  HINT_REPORTS_PREVIEW: 'hintreportspreview',
  HINT_REPORTS_TEMPLATE_FORM: 'hintreportstemplateform',
  HINT_REPORTS_TEMPLATE_FORM_NEW: 'hintreportstemplateform:new',
};

export const HintReportsPath = {
  DOWNLOAD: 'download',
  GENERATE: 'generate',
  PREVIEW: 'preview',
  TEMPLATES: 'templates',
  THEMES: 'themes',
  VALIDATE: 'validate',
  SENDEMAIL: 'sendemail',
  EXPORTTOSLIDES: 'exporttoslides',
  USAGE: 'usage',
};

export const HintReportsStatus = {
  inProgress: 'in_progress',
  error: 'error',
  success: 'success',
};

export const HintReportsThemeType = {
  client: 'client',
  instance: 'instance',
  default: 'default',
};

export const HintReportsThemePrefixes = {
  client: '@client_',
  instance: '.com@theme_',
  default: 'default@theme_',
  theme: '@theme_',
};

export const SelectOptions = {
  FIELD: 'field',
  LABEL: 'label',
  ID: 'id',
  NAME: 'name',
  TITLE: 'title',
};

export const SelectRefs = {
  dataviewSelect: 'data-view-select-',
  metricsSelect: 'metrics-select-',
  groupbysSelect: 'groupbys-select-',
  widgetSelect: 'widget-select-',
};

export const HintReportsDefaultOptions = {
  reportType: 'performance_report',
  audience: 'executive_team',
  focus_areas: ['kpis_only', 'campaign_highlights', 'insights_recommendations'],
};

export const DataSourcePrefix = {
  service: 'service_',
  category: 'category_',
};

export const Icons = {
  loading: 'loading',
  download: 'download',
};

export const DataFetchParams = {
  label: 'label',
};

export const HintReportsTabs = {
  SLIDES: 'slides',
  TEMPLATES: 'templates',
};

export const HintReportsTabEntityName = {
  [HintReportsTabs.SLIDES]: i18n.$t('SmartSlides'),
  [HintReportsTabs.TEMPLATES]: i18n.$t('Template'),
};

export const NEW_STRING = 'new';

export const CalendarDirection = {
  RIGHT: 'right',
};

export const HintReportTypes = {
  DATA_CATEGORY: 'dataCategory',
  DASHBOARD: 'dashboard',
  AI_AGENT_INSIGHTS: 'aiAgentInsights',
};

export const HintReportsTypesOptions = [
  {
    key: HintReportTypes.DATA_CATEGORY,
    value: i18n.$t('Data Category'),
  },
  {
    key: HintReportTypes.DASHBOARD,
    value: i18n.$t('Dashboard'),
  },
  {
    key: HintReportTypes.AI_AGENT_INSIGHTS,
    value: i18n.$t('AI Agent Insights'),
  },
];

export const HintReportNotificationType = {
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  SUCCESS: 'success',
};

export const TextConstants = {
  TEMPLATE_CHANGE_HEADING: i18n.$t('Your selected template has been updated.'),
  SECTIONS_WIDGETS_CHANGED_MESSAGE: i18n.$t(
    'Some sections or widgets in the linked dashboard were changed since you last used this template. A few items may have been deleted or moved.'
  ),
};

export const HintReportEvent = {
  DATA_CATEGORY_CLIENT_SELECTED: 'HintReportEvent:data_category_client_selected',
  DATA_CATEGORY_TEMPLATE_SELECTED: 'HintReportEvent:data_category_template_selected',
  DATA_CATEGORY_INIT_FORM: 'HintReportEvent:data_category_init_form',
  DATA_CATEGORY_RESET_FORM: 'HintReportEvent:data_category_reset_form',
  DATA_CATEGORY_FORM_SAVE_SUCCESS: 'HintReportEvent:data_category_form_save_success',
  DASHBOARD_CLIENT_SELECTED: 'HintReportEvent:dashboard_client_selected',
  DASHBOARD_TEMPLATE_SELECTED: 'HintReportEvent:dashboard_template_selected',
  DASHBOARD_INIT_FORM: 'HintReportEvent:dashboard_init_form',
  DASHBOARD_RESET_FORM: 'HintReportEvent:dashboard_reset_form',
  DASHBOARD_FORM_SAVE_SUCCESS: 'HintReportEvent:dashboard_form_save_success',
  DASHBOARD_UPDATE_WIDGET_IDS: 'HintReportEvent:dashboard_widget_ids',
};

export const StringConstants = {
  OBJECT: 'object',
  FIELDS: 'fields',
  STRING: 'string',
  DATAVIEW: 'dataview',
  METRICS: 'metrics',
  GROUPBYS: 'groupbys',
  NEAREST: 'nearest',
};

export const INITIALIZE_FIELDS_RETRY_LIMIT = 3;

export const SWATCHES = {
  // Production
  Essential: { a: '#0D45A4', b: '#FFFFFF' },
  Lite: { a: '#9C9283', b: '#E6DED2' },
  Dark: { a: '#1B1C25', b: '#5B7FFF' },

  // Staging
  Theme1: { a: '#0D45A4', b: '#FFFFFF' },
  Theme2: { a: '#9C9283', b: '#E6DED2' },
  Theme3: { a: '#1B1C25', b: '#5B7FFF' },
};

export const PROMPT_SUGGESTIONS = {
  'Omnichannel Performance Report':
    'Create a multi-source digital marketing report layout.\n' +
    'The report should dynamically adapt to 15–20 data sources (e.g., Google Ads, Meta, YouTube, TikTok, LinkedIn, Bing, etc.) and the metrics provided by TapClicks.\n' +
    'All insights, recommendations, and visuals must be strictly derived from the data supplied — never calculated or inferred externally.\n' +
    '------------------------------------------------------------\n' +
    'ADDITIONAL ITEMS\n' +
    '------------------------------------------------------------\n' +
    '- **Dynamic Images:**\n' +
    '  Automatically pick visually relevant images or icons based on the selected client or campaign theme.\n' +
    '  Maintain consistent image style, color palette, and placement across the entire report.\n' +
    '  Example: use consistent background textures or thematic images (e.g., fiber lines for Internet, mobile phones for telecom).\n' +
    '  Image style: clean, professional, and consistent — no watermarks or mismatched lighting.\n' +
    '--------------------------------------------\n' +
    'CORE INSTRUCTIONS\n' +
    '--------------------------------------------\n' +
    '1. Use ONLY the metrics, KPIs, and values directly provided by TapClicks or the input JSON.\n' +
    '   - Do NOT calculate or convert ratios (e.g., CTR, CPC, Conv. Rate) if not included.\n' +
    '   - If a field is missing, leave it blank or mark “N/A.”\n' +
    '   - Always preserve provided numeric formatting (%, $, decimal points).\n' +
    '2. Each insight, table, or chart must reference its data source.\n' +
    '   Example: [Metric: CTR | Source: Google Ads | Dataset: Traditional Internet]\n' +
    '3. Maintain 16:9 slide layout logic, clean spacing, and legible font sizes (≥18pt body / 22pt headers).\n' +
    '   Ensure NO text or data clipping, overlapping, or truncated visual elements.\n' +
    '--------------------------------------------\n' +
    'OUTPUT STRUCTURE\n' +
    '--------------------------------------------\n' +
    '## Slide 1 – Key of Terms\n' +
    'Create a concise “Key of Terms” section using definitions available or provided by the system.\n' +
    'If definitions exist in the metrics JSON (e.g., “CTR”, “Conversion”, “View”), extract them dynamically.\n' +
    'Example layout:\n' +
    '- **Impression** – When a user sees an ad from the campaign.\n' +
    '- **Click** – When a user clicks an ad leading to a landing page.\n' +
    '- **CTR (Click-Through Rate)** – Ratio of clicks to impressions.\n' +
    '- **Conversion** – A completed desired action (e.g., form, call, chat).\n' +
    'Ensure terminology matches the data schema in the system.\n' +
    '---\n' +
    '## Slide 2 – Executive Overview\n' +
    'Create a concise visual and textual overview:\n' +
    '- Total campaigns analyzed.\n' +
    '- Overall impressions, clicks, and conversions across all sources.\n' +
    '- Top 3 performing platforms (by conversions or CTR).\n' +
    '- Short paragraph summarizing performance direction:\n' +
    '  > “September showed growth across digital channels, led by Google Paid Search (CTR 8.4%) and Meta Ads (CPC $5.12). Business and Mobile segments showed modest engagement but high lead value.”\n' +
    'Add a short chart (e.g., bar chart: Conversions by Platform).\n' +
    '---\n' +
    '## Slide 3 – Combined Metric Summary\n' +
    'Present a cross-platform metrics table combining all sources:\n' +
    '| Platform | Campaigns | Impr. | Clicks | CTR | Cost | CPC | Conversions | Conv. Rate |\n' +
    'Highlight best performers in bold.\n' +
    'If the data includes Call Extensions, Chat, or Phone metrics — add as additional columns dynamically.\n' +
    'Include a footnote: “All data sourced directly from TapClicks feed ({date_range}).”\n' +
    '---\n' +
    '## Slide 4–N – Individual Source Breakdowns\n' +
    'For each platform/source (loop dynamically through all):\n' +
    '### Slide X – {Platform Name} Overview\n' +
    '- Show campaign group summary table:\n' +
    '  | Campaign | Impr. | Clicks | CTR | Cost | CPC | Conversions | Conv. Rate |\n' +
    '- Add a “Submetric Snapshot” (if available):\n' +
    '  e.g., Geo_Form, Contact_Chat, Call_Extensions, Contact_Phone.\n' +
    '- Include 1–2 bullet insights referencing specific metrics and campaign performance.\n' +
    '### Slide X+1 – {Platform Name} Keyword or Ad-Level Performance\n' +
    'If keyword/ad data exists:\n' +
    '| Keyword/Ad | Impr. | Clicks | CTR | CPC | Conversions |\n' +
    '- Rank top 10–20 entries by conversions or impressions.\n' +
    '- Recommend a horizontal bar chart for CTR visualization.\n' +
    '- Caption: “Source: {Platform} Keyword Data for {Campaign}”\n' +
    '### Slide X+2 – Auction or Competitive Insights (If available)\n' +
    '| Competitor | Impression Share | Overlap Rate | Position Above | Top of Page | Absolute Top |\n' +
    '- Include ↑ or ↓ arrows **only if provided by TapClicks metrics** (do not calculate trends).\n' +
    '- Add a one-sentence analysis:\n' +
    '  > “Spectrum.com maintained highest Top of Page rate at 93.9% (↑ from August), indicating strong competitive positioning.”\n' +
    '---\n' +
    '## Slide (After Source Sections) – Insights & Recommendations\n' +
    'Aggregate system-derived insights only.\n' +
    'Structure as three titled blocks:\n' +
    '### Key Wins\n' +
    'List campaigns or platforms with top metrics. Example:\n' +
    '- “Traditional Internet campaign leads all platforms in conversions (462) and CTR (8.48%). [Source: Google Ads].”\n' +
    '### Opportunities & Growth Levers\n' +
    'Identify underperforming areas using lowest provided metrics.\n' +
    '- “Business Solutions has lowest CTR (1.73%) — potential to refine keyword strategy.”\n' +
    '### Challenges & Next Steps\n' +
    'Summarize challenges visible in data.\n' +
    '- “Mobile campaigns show higher CPC ($8.65) with lower conversions — review mobile-specific CTAs.”\n' +
    'All statements must cite at least one metric and one source dataset.\n' +
    '---\n' +
    '## Slide – Recommendations by Platform\n' +
    'For each source, generate 2–3 short, direct, data-based recommendations.\n' +
    'Example:\n' +
    '- **Google Ads** – Increase investment in Fiber Internet; cost/conversion remains efficient (~$10). [Metric: CPC | Source: Google Ads]\n' +
    '- **Meta Ads** – Improve landing pages for mobile; conversion rate lags desktop.\n' +
    '- **YouTube** – Introduce localized video content for better VVR.\n' +
    '---\n' +
    '## Slide – Glossary of Metrics\n' +
    'Auto-generate a glossary for all unique metric names from the data.\n' +
    'Format:\n' +
    '| Metric | Definition | Source(s) |\n' +
    '|---------|-------------|-----------|\n' +
    '| CTR | Ratio of clicks to impressions. | Google, Meta |\n' +
    '| CPC | Average cost per click. | Google, Bing |\n' +
    '| Conversion | Completed action (lead, form, call, etc.) | All Sources |\n' +
    '---\n' +
    '## Final Slide – Thank You\n' +
    'Include:\n' +
    '**THANK YOU**\n' +
    '*Confidentiality Notice:* This report contains proprietary performance data and insights intended only for internal use.\n' +
    'Include contact or author information dynamically if available:\n' +
    '> Prepared by {Analyst_Name} | {Date}\n' +
    '> {Contact_Email or Organization}\n' +
    '---\n' +
    '--------------------------------------------\n' +
    'VISUAL STYLE & FORMATTING\n' +
    '--------------------------------------------\n' +
    '- Use tables and charts wherever applicable (no truncation).\n' +
    '- Maintain consistent color branding across slides.\n' +
    '- Ensure all numeric values retain original format (percentages, decimals, currency).\n' +
    '- Font hierarchy: Headings 22–26pt, Body 18–20pt.\n' +
    '- Include “Source:” notes under each visualization.\n' +
    '--------------------------------------------\n' +
    'GUARDRAILS\n' +
    '--------------------------------------------\n' +
    '- No inferred metrics, trends, or values.\n' +
    '- Every insight must cite at least one [Metric | Source | Dataset].\n' +
    '- If multiple timeframes exist (e.g., August vs. September), display both with provided Δ values — never self-computed.\n' +
    '- Maintain full data traceability to TapClicks system inputs.',
  'Keywork Performance Report':
    'Given the selected date range, analyze the performance of the keywords across all relevant campaigns. Focus on providing insights and actionable recommendations based on keyword performance, specifically highlighting the top-performing keywords. The analysis should be based on the highest quality score. Ensure that the insights are grounded in data, and any claims made are verifiable. Provide detailed recommendations to optimize future keyword strategies, including potential adjustments to bidding, targeting, and keyword selection. Clearly attribute all metrics to their respective data sources. Make sure no text or data is cut off on slides. Make sure font size of text is enough to be legible but not overlapping.',
  'Social Performance Report':
    '## Objective\n' +
    '\n' +
    'Analyze the performance of **paid social advertising campaigns** for the selected client and region over the selected date range.\n' +
    '\n' +
    'The report should support **multiple social platforms**, such as:\n' +
    '\n' +
    '* Facebook / Instagram (Meta)\n' +
    '* TikTok\n' +
    '* LinkedIn\n' +
    '* X (Twitter)\n' +
    '* Snapchat\n' +
    '  *(based on available TapClicks connections)*\n' +
    '\n' +
    '---\n' +
    '\n' +
    '## Key Focus Areas\n' +
    '\n' +
    'Focus on **core social performance KPIs**, including:\n' +
    '\n' +
    '* Reach\n' +
    '* Impressions\n' +
    '* Clicks / Landing Page Clicks\n' +
    '* CPC (Cost per Click)\n' +
    '* CPM (Cost per 1,000 Impressions)\n' +
    '* Total Leads (if available)\n' +
    '* Average Frequency (if available)\n' +
    '\n' +
    'Break down performance **by day or week**, depending on data availability.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '## Slide Breakdown\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 1 – Campaign Overview\n' +
    '\n' +
    '**Title:** {Client Name} – Social Campaign Performance Overview\n' +
    '\n' +
    '**Metrics (by Platform):**\n' +
    '\n' +
    '* Reach\n' +
    '* Impressions\n' +
    '* Clicks / Landing Page Clicks\n' +
    '* CPC\n' +
    '* CPM\n' +
    '* Total Leads (if available)\n' +
    '* Frequency (if available)\n' +
    '\n' +
    '**Dimensions:** Day / Week\n' +
    '**Source:** Paid Social Platforms\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 2 – Platform Performance Comparison\n' +
    '\n' +
    '**Title:** Platform Performance Comparison\n' +
    '\n' +
    '**Metrics:**\n' +
    '\n' +
    '* Impressions\n' +
    '* Reach\n' +
    '* CPM\n' +
    '* CPC\n' +
    '\n' +
    '**Analysis:**\n' +
    '\n' +
    '* Compare performance across social platforms.\n' +
    '* Highlight differences in CPM and CPC.\n' +
    '* Summarize overall traffic and efficiency trends.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 3 – Platform-Level Performance Breakdown\n' +
    '\n' +
    '**Title:** {Platform Name} – Key Metrics\n' +
    '\n' +
    '**Metrics:**\n' +
    '\n' +
    '* Reach\n' +
    '* Impressions\n' +
    '* Clicks\n' +
    '* CPC\n' +
    '* CPM\n' +
    '* Leads / Conversions (if available)\n' +
    '* Frequency (if available)\n' +
    '\n' +
    '**Analysis:**\n' +
    '\n' +
    '* Review delivery trends by day/week.\n' +
    '* Evaluate cost efficiency and engagement.\n' +
    '* Call out top-performing periods or spikes.\n' +
    '\n' +
    '**Source:** {Platform Name}\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 4 – Cross-Platform Performance Comparison\n' +
    '\n' +
    '**Title:** Cross-Platform Performance Comparison\n' +
    '\n' +
    '**Metrics:**\n' +
    '\n' +
    '* CPM\n' +
    '* CPC\n' +
    '* Reach\n' +
    '* Impressions\n' +
    '* Clicks\n' +
    '\n' +
    '**Analysis:**\n' +
    '\n' +
    '* Compare platforms side-by-side.\n' +
    '* Identify strengths and weaknesses by channel.\n' +
    '* Highlight cost vs. scale tradeoffs.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 5 – Insights & Recommendations\n' +
    '\n' +
    '**Title:** Insights & Recommendations\n' +
    '\n' +
    '**Insights:**\n' +
    '\n' +
    '* Identify platforms driving the most reach or clicks.\n' +
    '* Call out inefficiencies (high CPC, high frequency, low engagement).\n' +
    '* Highlight pacing or delivery issues.\n' +
    '\n' +
    '**Recommendations:**\n' +
    '\n' +
    '* Optimize creatives or targeting to improve click-through.\n' +
    '* Adjust frequency to reduce fatigue.\n' +
    '* Shift budget toward higher-performing platforms.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 6 – Benchmarks & Best Practices *(Optional)*\n' +
    '\n' +
    '**Title:** Benchmarks & Best Practices\n' +
    '\n' +
    '**Content:**\n' +
    '\n' +
    '* Compare performance to available industry benchmarks (if provided).\n' +
    '* Call out CPC, CPM, or CTR ranges.\n' +
    '* Note gaps between current performance and typical benchmarks.\n' +
    '\n' +
    '⚠️ Only include benchmarks if available in the dataset.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 7 – Business & Audience Context *(Optional)*\n' +
    '\n' +
    '**Title:** Campaign Context & Audience Insights\n' +
    '\n' +
    '**Analysis:**\n' +
    '\n' +
    '* Provide business-relevant insights based on audience behavior.\n' +
    '* Highlight platform fit for the client’s industry or audience type.\n' +
    '* Keep insights tied to observed data patterns.\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 8 – Appendix\n' +
    '\n' +
    '**Title:** Appendix – Detailed Metrics\n' +
    '\n' +
    '**Metrics:**\n' +
    '\n' +
    '* Impressions\n' +
    '* Reach\n' +
    '* Clicks\n' +
    '* CPC\n' +
    '* CPM\n' +
    '* Leads\n' +
    '* Frequency\n' +
    '\n' +
    '**Breakdown:** Day / Week\n' +
    '**Source:** Paid Social Platforms\n' +
    '\n' +
    '---\n' +
    '\n' +
    '### Slide 9 – Thank You\n' +
    '\n' +
    '**Title:** Thank You\n' +
    '\n' +
    '**Message:**\n' +
    'Thank you for reviewing the campaign performance.\n' +
    'Please reach out with any questions or requests for deeper analysis.\n',
  'Campaign Performance - Google Ads and Facebook Ads':
    'Generate a campaign performance report in slide format for the selected date range.\n' +
    '\n' +
    'The report should focus on performance across Google Ads and Facebook Ads, with insights and recommendations provided on a single slide at the end. Ensure the data is clearly attributed to its source. for google ads filter the data to show campaign type contains "search"\n' +
    '\n' +
    'Slide Breakdown and Titles\n' +
    '\n' +
    'Slide 1: Campaign Title & Introduction\n' +
    'Title: [Campaign Name] – Performance Report\n' +
    'Introduction: Brief overview of the campaign, reporting period, and platforms analyzed (Google Ads, Facebook Ads).\n' +
    '\n' +
    'Slide 2: Google Ads Performance\n' +
    'Key Metrics:\n' +
    '\n' +
    'All Conversions\n' +
    '\n' +
    'All Conversion Rate \n' +
    '\n' +
    'CTR (Click-Through Rate)\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Dimensions:\n' +
    '\n' +
    'Campaign Name\n' +
    '\n' +
    'Source: Google Ads\n' +
    '\n' +
    'Slide 3: Facebook Ads Demographic Performance\n' +
    'Key Metrics:\n' +
    '\n' +
    'CTR (Link Click-Through Rate)\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Dimensions:\n' +
    '\n' +
    'Campaign\n' +
    '\n' +
    'Source: Facebook Ads\n' +
    '\n' +
    'Slide 4: Insights & Recommendations\n' +
    'Insights:\n' +
    'Provide high-level analysis across Google Ads and Facebook Ads data — highlight top-performing segments, conversion drivers, and device-level trends.\n' +
    '\n' +
    'Recommendations:\n' +
    'Offer actionable strategies to optimize ad performance, targeting, and engagement for future campaigns.\n' +
    '\n' +
    'Source: Derived from data insights across Google Ads and Facebook Ads.\n' +
    '\n' +
    'Slide 5: Key Definitions and Glossary\n' +
    'Include definitions for key terms such as:\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'CTR (Click-Through Rate)\n' +
    '\n' +
    'CPC (Cost Per Click)\n' +
    '\n' +
    'Conversions\n' +
    '\n' +
    'Engagement Rate\n' +
    '\n' +
    'Source: Attribute definitions to respective platform glossaries (e.g., Google Ads Help, Meta Business Glossary).\n' +
    '\n' +
    'Slide 6: Confidentiality Notice\n' +
    'Confidentiality Statement:\n' +
    '“This report contains confidential campaign performance data. Unauthorized distribution or sharing of this information is strictly prohibited.”\n' +
    'Make sure no text or data is cut off on slides. Make sure font size of text is enough to be legible but not overlapping.',
  'Search, Social & Analytics - Campaign Performance':
    'Generate a campaign performance report in slide format for the for the selected date range.\n' +
    'The report should focus on performance across Google Search Ads, Facebook Ads, and Google Analytics 4 (GA4), with insights and recommendations provided on a single slide at the end.\n' +
    'Ensure the data is clearly attributed to its source, and include only Google Ads data where Campaign Type contains “SEARCH.”\n' +
    '\n' +
    'Slide Breakdown and Titles\n' +
    '\n' +
    'Slide 1: Campaign Title & Introduction\n' +
    'Title: [Campaign Name] – Performance Report\n' +
    'Introduction: Brief overview of the campaign, reporting period, and platforms analyzed (Google Search Ads, Facebook Ads, GA4).\n' +
    '\n' +
    'Slide 2: Google Search Ads Performance\n' +
    'Scope:\n' +
    'Include only Google Ads data where Campaign Type contains “SEARCH.”\n' +
    '\n' +
    'Key Metrics:\n' +
    '\n' +
    'All Conversions\n' +
    '\n' +
    'All Conversion Rate\n' +
    '\n' +
    'Average CPC\n' +
    '\n' +
    'Click-Through Rate (CTR)\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Cost\n' +
    '\n' +
    'Cost Per Conversion\n' +
    '\n' +
    'Dimensions:\n' +
    '\n' +
    'Ad Group\n' +
    '\n' +
    'Campaign Name\n' +
    '\n' +
    'Device\n' +
    '\n' +
    'Source: Google Ads\n' +
    '\n' +
    'Slide 3: Facebook Ads Demographic Performance\n' +
    'Key Metrics:\n' +
    '\n' +
    'Click-Through Rate (CTR)\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Dimensions:\n' +
    '\n' +
    'Age\n' +
    '\n' +
    'Gender\n' +
    '\n' +
    'Source: Facebook Ads\n' +
    '\n' +
    'Slide 4: Google Analytics 4 – Traffic Source & Engagement Overview\n' +
    'Key Metrics:\n' +
    '\n' +
    'Sessions\n' +
    '\n' +
    'Engaged Sessions\n' +
    '\n' +
    'Engagement Rate\n' +
    '\n' +
    'Key Events\n' +
    '\n' +
    'New Users\n' +
    '\n' +
    'Purchase Revenue\n' +
    '\n' +
    'Total Ad Revenue\n' +
    '\n' +
    'Dimensions:\n' +
    '\n' +
    'Session Source\n' +
    '\n' +
    'Session Medium\n' +
    '\n' +
    'Source: Google Analytics 4\n' +
    '\n' +
    'Slide 5: Insights & Recommendations\n' +
    'Insights:\n' +
    'Provide high-level analysis across Search, Social, and Analytics data — highlight top-performing segments, conversion drivers, and device-level trends.\n' +
    '\n' +
    'Recommendations:\n' +
    'Offer actionable strategies to optimize ad performance, targeting, and engagement for future campaigns.\n' +
    '\n' +
    'Source: Derived from data insights across Google Ads, Facebook Ads, and GA4.\n' +
    '\n' +
    'Slide 6: Key Definitions and Glossary\n' +
    'Include definitions for key terms such as:\n' +
    '\n' +
    'Impressions\n' +
    '\n' +
    'Clicks\n' +
    '\n' +
    'CTR (Click-Through Rate)\n' +
    '\n' +
    'CPC (Cost Per Click)\n' +
    '\n' +
    'Conversions\n' +
    '\n' +
    'Engagement Rate\n' +
    '\n' +
    'Purchase Revenue\n' +
    '\n' +
    'Source: Attribute definitions to respective platform glossaries (e.g., Google Ads Help, Meta Business Glossary, GA4 Documentation).\n' +
    '\n' +
    'Slide 7: Confidentiality Notice\n' +
    'Confidentiality Statement:\n' +
    '“This report contains confidential campaign performance data. Unauthorized distribution or sharing of this information is strictly prohibited.”\n' +
    '\n' +
    'Additional Instructions:\n' +
    '\n' +
    'Present data in a clean, visually organized slide format using tables or charts for clarity.\n' +
    '\n' +
    'Ensure each metric and insight is traceable to its data source.\n' +
    '\n' +
    'Use consistent color-coding or platform branding (Google, Meta, GA4) for easy visual distinction.\n' +
    '\n' +
    'Maintain a professional, minimalistic aesthetic with clear section titles and concise commentary.\n' +
    'Make sure no text or data is cut off on slides. Make sure font size of text is enough to be legible but not overlapping.',
};

export const USAGE_WARNING_THRESHOLD = 0.8;

export const HintReportEntityType = {
  CLIENT: 'client',
  CLIENT_GROUP: 'client_group',
  CLUSTER: 'cluster',
  SMART_CAMPAIGN: 'smart_campaign',
  ALL: 'all',
};

export const RULE_REQUIRED = 'required';

export const AI_AGENT_INSIGHTS_TEMPLATE_NAME = 'AI Agent Insights Report';
